import { styled } from 'styled-components';

import { LegacyPrimaryButton } from 'components/LegacyButton/LegacyPrimaryButton';
import { StyledNativeLinkWithRef } from 'components/Link/StyledNativeLinkWithRef';
import { Body } from 'components/Text/Body';
import { H2 } from 'components/Text/H2';
import type { CmsApiChecklistBlockData } from 'modules/cms/api/types/blocks/CmsApiChecklistBlock';
import { colors, cssBreakpoints } from 'theme/theme';

import { CmsCheckIcon } from './CmsCheckIcon';

type Props = {
  data: CmsApiChecklistBlockData;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: center;

  --cms-checklist-col-count: 1;

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    --cms-checklist-col-count: 2;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    --cms-checklist-col-count: 3;
  }

  ul {
    list-style: none;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(var(--cms-checklist-col-count), 1fr);
    grid-auto-rows: auto;
    gap: 36px;
    width: 100%;
    max-width: min(960px, 100vw);
  }

  li {
    display: grid;
    grid-template-columns: 15px auto;
    align-items: start;
    gap: 18px;
    line-height: 1.75;
    overflow: hidden;
    color: ${colors.lightContentGrey};

    & svg {
      margin-block-start: 6px;
    }

    & span {
      line-height: 1.4;
    }
  }
`;

export function CmsChecklistBlock({ data }: Props) {
  return (
    <Container>
      {data.headline ? <H2 textAlign="center">{data.headline}</H2> : null}
      <ul>
        {data.items.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={`${index}-${item}`}>
            <CmsCheckIcon />
            <Body tag="span">{item}</Body>
          </li>
        ))}
      </ul>
      {data.buttonText && data.buttonUrl ? (
        <LegacyPrimaryButton
          component={StyledNativeLinkWithRef}
          href={data.buttonUrl}
        >
          {data.buttonText}
        </LegacyPrimaryButton>
      ) : null}
    </Container>
  );
}
